import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { DialogEnterActionService } from './services/dialog-enter-action.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'al-ui-nebular';

  maintenanceMode = false;
  translationsLoaded = false;

  constructor(
    private route: ActivatedRoute,
    t: TranslateService,
    dialogEnterAction: DialogEnterActionService
  ) {
    t.get('init').subscribe(() => {
      this.translationsLoaded = true;
    });
    // Enter in dialog fields → next empty required field, else primary action.
    dialogEnterAction.install();
  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const maintenanceMode = urlParams.get('maintenanceMode');
    if (maintenanceMode === 'false') {
      this.maintenanceMode = false;
    } else {
      this.maintenanceMode = environment.maintenanceMode;
    }

    if (this.maintenanceMode) {
      console.warn('Alphabees maintenance mode is active');
    }
  }
}
